export const actionAdmin = {
  table: {
    id: 'ID',
    message: 'Message',
    path: 'Path',
    detail: 'Incident details',
    name: 'Name',
    methodType: 'Method Type',
    typeAction: 'Type Action',
    oldData: 'Old Data',
    newData: 'New Data',
    createdAt: 'Created At',
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    import: 'Import',
    attendance: 'Attendance',
    employee: 'Employee',
    csvInsert: 'Csv Insert',
    csvUpdate: 'Csv Update',
  },
  pageHeader: {
    title: 'History change action',
  },
}
